import type * as PdfjsLib from "pdfjs-dist"

let pdfjsLibCache: typeof PdfjsLib | null = null

// Export a getter that ensures pdfjs is loaded (browser-only)
export async function getPdfJs(): Promise<typeof PdfjsLib> {
  if (typeof window === "undefined") {
    throw new Error("PDF.js can only be used in browser environment")
  }
  if (pdfjsLibCache) {
    return pdfjsLibCache
  }
  const lib = await import("pdfjs-dist")
  lib.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
  ).toString()
  pdfjsLibCache = lib
  return lib
}

// For backwards compatibility - will be null during SSR
export const pdfjsLib = null as typeof PdfjsLib | null
